moveElementsInFooter();
manipulateNewsletter();
